export const preventDefault = event => {
    event.preventDefault();
};
